import { render, staticRenderFns } from "./ToolbarTyhjaTaulukko.vue?vue&type=template&id=487d5d66&"
import script from "./ToolbarTyhjaTaulukko.vue?vue&type=script&lang=js&"
export * from "./ToolbarTyhjaTaulukko.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VRow,VToolbar})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('487d5d66')) {
      api.createRecord('487d5d66', component.options)
    } else {
      api.reload('487d5d66', component.options)
    }
    module.hot.accept("./ToolbarTyhjaTaulukko.vue?vue&type=template&id=487d5d66&", function () {
      api.rerender('487d5d66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ToolbarTyhjaTaulukko.vue"
export default component.exports